import { render } from "./VF-input.vue?vue&type=template&id=497d8495"
import script from "./VF-input.vue?vue&type=script&lang=js"
export * from "./VF-input.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__